import { render, staticRenderFns } from "./DetailType1.vue?vue&type=template&id=16f0a50d&"
import script from "./DetailType1.vue?vue&type=script&lang=js&"
export * from "./DetailType1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports